import { createFileRoute } from '@tanstack/react-router';

import { PatientDetailsPage } from '@/app/patient-details/patient-details-page';

/** Which section the profile was opened from — drives breadcrumb + sidebar. */
export type PatientDetailsSearch = { from?: 'referrals' };

function PatientDetailsRoute(): React.JSX.Element {
  const { patientId } = Route.useParams();
  const { from } = Route.useSearch();
  return <PatientDetailsPage patientId={patientId} from={from} />;
}

export const Route = createFileRoute('/patients/$patientId')({
  validateSearch: (search: Record<string, unknown>): PatientDetailsSearch => ({
    from: search['from'] === 'referrals' ? 'referrals' : undefined,
  }),
  component: PatientDetailsRoute,
});
